import GraphicPackingActionField from './graphic-packing-action-field';
import GraphicPackingLinkField from './graphic-packing-link-field';
import GraphicPackingViewField from './graphic-packing-view-field';
import GraphicPackingRadioField from './graphic-packing-radio-field';
const GraphicPackingFields = {
    Action: GraphicPackingActionField,
    Link: GraphicPackingLinkField,
    View: GraphicPackingViewField,
    Radio: GraphicPackingRadioField,
};

export default GraphicPackingFields;